import React from 'react';
import AppProviders from 'providers';
import Router from './router/router';

const App: React.FC = () => {
  return (
    <AppProviders>
      <Router />
    </AppProviders>
  );
};

export default App;
